module.exports = __webpack_public_path__ + "static/media/16UNODC34.bf666763.jpg";